import React from 'react';

export const ArrowIcon = ({ className }: { className?: string }) => (
    <svg
        className={className}
        fill="none"
        height="20"
        viewBox="0 0 13 20"
        width="13"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            clipRule="evenodd"
            d="M3 0.00390625L13 10.0039L3 20.0039L0.5 17.5039L8 10.0039L0.5 2.50391L3 0.00390625Z"
            fill="#F1F1F1"
            fillRule="evenodd"
        />
    </svg>
);
